module.exports = __webpack_public_path__ + "img/arrival-transfer-centurion._0.016d6ec1.jpg";